import axios from "@/libs/api.request";
import { pests } from "./api_url";
/**
 * 删除人员
 * @param data
 * @returns {*|{responseURL}}
 */
export const maintain_del = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.maintain_del,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 编辑人员
 * @param data
 * @returns {*|{responseURL}}
 */
export const maintain_update = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.maintain_update,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 获取人员列表
 * @param data
 * @returns {*|{responseURL}}
 */
export const maintain_list = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.maintain_list,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 新增人员
 * @param data
 * @returns {*|{responseURL}}
 */
export const maintain_add = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.maintain_add,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 新增人员
 * @param data
 * @returns {*|{responseURL}}
 */
export const project_del = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.project_del,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 编辑项目
 * @param data
 * @returns {*|{responseURL}}
 */
export const project_update = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.project_update,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 项目列表
 * @param data
 * @returns {*|{responseURL}}
 */
export const project_list = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.project_list,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 新增项目
 * @param data
 * @returns {*|{responseURL}}
 */
export const project_add = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.project_add,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 删除防制分类
 * @param data
 * @returns {*|{responseURL}}
 */
export const prevent_cate_del = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.prevent_cate_del,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 防制分类列表
 * @param data
 * @returns {*|{responseURL}}
 */
export const prevent_cate_list = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.prevent_cate_list,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 新增防制分类
 * @param data
 * @returns {*|{responseURL}}
 */
export const prevent_cat_add = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.prevent_cat_add,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 编辑防制分类
 * @param data
 * @returns {*|{responseURL}}
 */
export const prevent_cat_update = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.prevent_cat_update,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 删除楼层
 * @param data
 * @returns {*|{responseURL}}
 */
export const floor_del = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.floor_del,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 编辑楼层
 * @param data
 * @returns {*|{responseURL}}
 */
export const floor_update = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.floor_update,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 楼层列表
 * @param data
 * @returns {*|{responseURL}}
 */
export const floor_list = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.floor_list,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 新增楼层
 * @param data
 * @returns {*|{responseURL}}
 */
export const floor_add = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.floor_add,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 删除建筑物
 * @param data
 * @returns {*|{responseURL}}
 */
export const building_del = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.building_del,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 编辑建筑物
 * @param data
 * @returns {*|{responseURL}}
 */
export const building_add = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.building_add,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 建筑物列表
 * @param data
 * @returns {*|{responseURL}}
 */
export const building_list = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.building_list,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 编辑建筑物
 * @param data
 * @returns {*|{responseURL}}
 */
export const building_update = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.building_update,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 获取告警相关下拉
 * @param data
 * @returns {*|{responseURL}}
 */
export const alarm_about = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.alarm_about,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 删除告警
 * @param data
 * @returns {*|{responseURL}}
 */
export const device_del = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.device_del,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 编辑设备
 * @param data
 * @returns {*|{responseURL}}
 */
export const device_update = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.device_update,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 设备列表
 * @param data
 * @returns {*|{responseURL}}
 */
export const device_list = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.device_list,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 新增设备
 * @param data
 * @returns {*|{responseURL}}
 */
export const device_add = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.device_add,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 获取设备分类和用途
 * @param data
 * @returns {*|{responseURL}}
 */
export const device_about = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.device_about,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 审核维保记录
 * @param data
 * @returns {*|{responseURL}}
 */
export const maintenance_audit = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.maintenance_audit,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 维保管理列表
 * @param data
 * @returns {*|{responseURL}}
 */
export const maintenance_list = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.maintenance_list,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 删除告警
 * @param data
 * @returns {*|{responseURL}}
 */
export const alarm_del = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.alarm_del,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 处理告警
 * @param data
 * @returns {*|{responseURL}}
 */
export const handle_alarm = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.handle_alarm,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 获取告警列表
 * @param data
 * @returns {*|{responseURL}}
 */
export const alarm_list = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.alarm_list,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 查看维保报告
 * @param data
 * @returns {*|{responseURL}}
 */
export const maintenance_report = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.maintenance_report,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 下载维保报告
 * @param data
 * @returns {*|{responseURL}}
 */
export const maintenance_download = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.maintenance_download,
    params: {
      ...data,
      country_code
    },
    method: "get"
  });
};
/**
 * 事件记录
 * @param data
 * @returns {*|{responseURL}}
 */
export const device_event_history = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.device_event_history,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 中边中部报警统计
 * @param data
 * @returns {*|{responseURL}}
 */
export const get_alarm_info = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.get_alarm_info,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 左上角设备统计
 * @param data
 * @returns {*|{responseURL}}
 */
export const get_device_info = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.get_device_info,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 获取左下角近一年新增设备
 * @param data
 * @returns {*|{responseURL}}
 */
export const device_year_increase = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.device_year_increase,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 右侧底部项目列表（中部经纬度）统计
 * @param data
 * @returns {*|{responseURL}}
 */
export const indexProject_list = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.indexProject_list,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 获取下载token
 * @param data
 * @returns {*|{responseURL}}
 */
export const getdownloadtoken = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.getdownloadtoken,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 当前用户修改密码
 * @param data
 * @returns {*|{responseURL}}
 */
export const updatepwd = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.updatepwd,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 在离线记录
 * @param data
 * @returns {*|{responseURL}}
 */
export const device_onoffline_history = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.device_onoffline_history,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 在离线记录
 * @param data
 * @returns {*|{responseURL}}
 */
export const maintenance_download_zip = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.maintenance_download_zip,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 在离线记录
 * @param data
 * @returns {*|{responseURL}}
 */
export const building_trend = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.building_trend,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 获取固件信息
 * @param data
 * @returns {*|{responseURL}}
 */
export const get_firmware_info = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.get_firmware_info,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 升级固件
 * @param data
 * @returns {*|{responseURL}}
 */
export const upup_firmware = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.upup_firmware,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 导入设备
 * @param data
 * @returns {*|{responseURL}}
 */
export const device_file_import = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.device_file_import,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 查看失败的行
 * @param data
 * @returns {*|{responseURL}}
 */
export const device_file_fail_list = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.device_file_fail_list,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 导入的文件列表
 * @param data
 * @returns {*|{responseURL}}
 */
export const device_file_list = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.device_file_list,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * wifi设置
 * @param data
 * @returns {*|{responseURL}}
 */
export const set_device_wifi = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.set_device_wifi,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 获取控制设置内容
 * @param data
 * @returns {*|{responseURL}}
 */
export const get_device_cmd_config = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.get_device_cmd_config,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 控制设置
 * @param data
 * @returns {*|{responseURL}}
 */
export const device_cmd_config = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.device_cmd_config,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 蝇害密度分析
 * @param data
 * @returns {*|{responseURL}}
 */
export const midu_analysis = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.midu_analysis,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 实时查看
 * @param data
 * @returns {*|{responseURL}}
 */
export const real_time_view = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.real_time_view,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * ajax拉取图片到web服务器接口
 * @param data
 * @returns {*|{responseURL}}
 */
export const refresh_device_pic_ajax = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.refresh_device_pic_ajax,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 项目管理 获取公司列表
 * @param data
 * @returns {*|{responseURL}}
 */
export const company_list = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: pests.company_list,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
